/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CarveOutQuote } from './CarveOutQuote';
import {
    CarveOutQuoteFromJSON,
    CarveOutQuoteFromJSONTyped,
    CarveOutQuoteToJSON,
    CarveOutQuoteToJSONTyped,
} from './CarveOutQuote';

/**
 * 
 * @export
 * @interface AddCarveOutQuote201Response
 */
export interface AddCarveOutQuote201Response {
    /**
     * 
     */
    data?: CarveOutQuote;
}

/**
 * Check if a given object implements the AddCarveOutQuote201Response interface.
 */
export function instanceOfAddCarveOutQuote201Response(value: object): value is AddCarveOutQuote201Response {
    return true;
}

export function AddCarveOutQuote201ResponseFromJSON(json: any): AddCarveOutQuote201Response {
    return AddCarveOutQuote201ResponseFromJSONTyped(json, false);
}

export function AddCarveOutQuote201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddCarveOutQuote201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CarveOutQuoteFromJSON(json['data']),
    };
}

export function AddCarveOutQuote201ResponseToJSON(json: any): AddCarveOutQuote201Response {
    return AddCarveOutQuote201ResponseToJSONTyped(json, false);
}

export function AddCarveOutQuote201ResponseToJSONTyped(value?: AddCarveOutQuote201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CarveOutQuoteToJSON(value['data']),
    };
}

